import axios from '../axiosInstance';

export default class {
  constructor(options) {
    this.core = options.core;
    this.URL = `${options.baseUrl}/rauth/organizations`;
  }

  /**
   * Create new organization. DEPRECATED
   * @param {Object} object representing an organization
   * @returns {Object} unserialized organization with mongo id and main_account_id
   *     _id: {
   *      $oid: <hash_id>
   *    },
   *    main_account_id: <ref_id>,
   *    organization_name: String,
   *    department_name: String
   *    [....]
   */
  async create(organization) {
    try {
      const Model = Object.getPrototypeOf(organization).constructor;
      const results = await axios.post(`${this.URL}/`, organization);
      return new Model(results.data);
    } catch (e) {
      throw new Error('organizationsService:create: ' + e.message);
    }
  }

  /**
   * Retrive all organizations
   * @param {Object} Model class model of expected organization
   * @param {Object} [params] optional key,value pairs of query params
   * @returns {Array} array of organizations
   */
  async get(Model, params = {}) {
    try {
      const model = { model_name: Model.MODEL_NAME() };
      params = params ? Object.assign({}, params, model) : model;

      const results = await axios.get(`${this.URL}/`, {
        params: params,
      });
      return results.data.map((d) => new Model(d));
    } catch (e) {
      throw new Error('organizationsService:get: ' + e.message);
    }
  }

  /**
   * Retrive a specific organization by id.
   * @param {Object} Model class model of expected organization
   * @param {String} Object id of organiztion
   * @returns {Object} unserialized organization with mongo id and main_account_id
   *     _id: {
   *      $oid: <hash_id>
   *    },
   *    main_account_id: <ref_id>,
   *    organization_name: String,
   *    department_name: String
   *    [....]
   */
  async getByID(Model, id) {
    try {
      const results = await axios.get(`${this.URL}/${id}`);
      return new Model(results.data);
    } catch (e) {
      throw new Error('organizationsService:getByID: ' + e.message);
    }
  }

  /**
   * Update organization.
   * @param {Object} object representing a organization
   * @returns {Object} unserialized organization with mongo id and main_account_id
   *     _id: {
   *      $oid: <hash_id>
   *    },
   *    main_account_id: <ref_id>,
   *    organization_name: String,
   *    department_name: String
   *    [....]
   */
  async update(organization) {
    try {
      const Model = Object.getPrototypeOf(organization).constructor;
      const results = await axios.put(`${this.URL}/${organization.id}`, organization);
      return new Model(results.data);
    } catch (e) {
      throw new Error('organizationsService:update: ' + e.message);
    }
  }
}
